import { RefObject, useEffect } from 'react';

interface InstancesToDetect {
    elemRef: RefObject<HTMLDivElement | HTMLUListElement | HTMLButtonElement> | undefined;
    onClickOutside: () => void;
}

export const useClickDetector = (instances: InstancesToDetect[]) => {
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function handleClick(event: any) {
            instances.forEach((instance) => {
                if (instance.elemRef?.current && !instance.elemRef.current.contains(event.target)) {
                    instance.onClickOutside();
                }
            });
        }

        // Bind the event listener
        document.addEventListener('mousedown', handleClick);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClick);
        };
    }, [instances]);

    return null;
};
